import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion } from 'react-bootstrap';
import { faPlus, faFileAlt, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faPrint, faTrash, faCircleCheck, faChevronDown, faGear, faCog, faTimes } from '@fortawesome/free-solid-svg-icons';
import edit from "../../../assets/images/edit.png";
import view from "../../../assets/images/view.png";
import show from "../../../assets/images/show.png";
import mail from "../../../assets/images/mail.png";
import { withRFSToken } from '../../../Services/axios.js';
import Select from 'react-select';
import MessageBox from '../../../Components/common/MessageBox';
import Docmnt from '../../../assets/images/google-docs.png';
import { toast } from 'react-toastify';
import * as mammoth from 'mammoth'; 
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const DocManagement = () => {
  const storedData = JSON.parse(localStorage.getItem('RS'));

  const [activeTab, setActiveTab] = useState(storedData?.doc_tab || 'Announcement');
  const [disLoading, setDisLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [gridSelect, setGridSelect] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [tabCounts, setTabCounts] = useState({});
  const [showReadersModal, setShowReadersModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [innerData, setInnerData] = useState([]);
  const [awbList, setAwbList] = useState([]);
  const [gridData, setGridData] = useState({
    // Active: [],
    Announcement: [],
    Departments: [],
    Private: [],
    All_Publish: [],
    Read_sign: []
  });

  const gridRefs = {
    // Active: useRef(null),
    Announcement: useRef(null),
    Departments: useRef(null),
    Private: useRef(null),
    All_Publish: useRef(null),
    Read_sign: useRef(null),
  };

  const [createModal, setCreateModal] = useState(false);
  const initFdata = {
    publish_for: 'departments',
    is_publish: '0',
    // docName: '',
    version: '',
    department_id: [],
    template_id: '',
  }
  const [formData, setFormData] = useState(initFdata);
  const [imageOptions, setImageOptions] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const readSignType = [
    { label: "One Time", value: "1" },
    { label: "Monthly", value: "2" },
    { label: "Quarterly", value: "3" },
    { label: "Bi Annually", value: "4" },
    { label: "Yearly", value: "5" },

  ];

  const fetchAwb = async () => {
    try {
      const res = await withRFSToken.post("service-recovery/all-awb-number?tab=document")
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformData = innerData ? innerData.map((item) => ({
            label: item.master_airway_bill,
            value: item.documentable_id,
            documentable_type: item.documentable_type
          })) : []
          setAwbList(transformData)
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    setFilterApplied(false);
    // if (selectedRowData) {
    //   setSelectedRowData(null)
    // }
    setGridSelect([]);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setGridData(prev => ({ ...prev, [tab]: [] }));
    }, 1);


  };
  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (isMounted.current) return;

    setIsLoading(false);
    setGridData({ active: {} });

    fetchImage();
    fetchdeparrtment();
    fetctemplatehData();
    fetchAwb();

    // localStorage.removeItem('RS')
    isMounted.current = true;
  }, []);

  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.QMS;
      jqxCookieCall()
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'name', type: 'string' },
          { name: 'version', type: 'string' },
          { name: 'access', type: 'string' },
          { name: 'docType', type: 'string' },
          { name: 'updated_at', type: 'string' },
          { name: 'updated_by', type: 'string' },
          { name: 'created_by', type: 'string' },
          { name: 'tracking', type: 'string' },
          { name: 'title', type: 'string' },
          { name: 'access', type: 'string' },
          { name: 'published_by', type: 'string' },
          { name: 'tracking', type: 'string' },
          { name: 'document_title', type: 'string' },
          { name: 'is_signed', type: 'string' },
          { name: 'reminder', type: 'string' },
          { name: 'readers', type: 'string' },
          { name: 'type', type: 'string' },
          { name: 'ref_no', type: 'string' },
          { name: 'created_at', type: 'string' },
          { name: 'updated_by', type: 'string' },
          { name: 'last_edited_by', type: 'string' },
          { name: 'organisation', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}document/list?tab=${activeTab}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTabCounts(data.tabCounts);
          // setTabCounts(prevCounts => ({
          //   ...prevCounts,
          //   [activeTab]: data.TotalRows || 0
          // }));

        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);


      const columns = getColumnsForTab(activeTab);

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 50,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        }
      };

      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);

      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRefs[activeTab].current).off('click', '.row_edit');
      window.$(gridRefs[activeTab].current).off('click', '.row_view');

      // Handle edit (only Active tab)
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            // console.log('Edit Row Data:', rowData);
            setFormData({
              ...rowData,
              department_id: rowData.department_id ? rowData.department_id.split(',').map(id => parseInt(id)) : []
            });
            setCreateModal(true); // open edit modal
          }
        }
      });

      // Handle view (all other tabs)
      window.$(gridRefs[activeTab].current).on('click', '.row_view', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            // console.log("View Row Data:", rowData);
            const data = {
              check: activeTab === 'Read_sign' ? false : true,
              id: rowData.id,
              doc_tab: activeTab
            }
            localStorage.setItem('RS', JSON.stringify(data))
            window.location.href = '/ReadSign';
            // window.open('/ReadSign', '_blank');
          }
        }
      });
    }
  }, [gridData, activeTab]);


  const loadDetails = async (id) => {
    // console.log("id for details==>", id.id);

    try {
      const res = await withRFSToken.post("/document/details", { "id": id.id });
      setInnerData(res.data.response_data);
      setViewModal(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const createRow = async (id) => {
    try {
      const res = await withRFSToken.post("/document/create-row", { "id": id.id });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // -------------------- HELPERS ---------------------
  const actionRenderer = (tab) => {
    if (tab === "Active") {
      return () => '<div class="grid_actions"><img src="' + edit + '" class="row_edit" title="Edit"/></div>';
    } else {
      return () => '<div class="grid_actions"><img src="' + view + '" class="row_view" title="View"/></div>';
    }
  };

  const getColumnsForTab = (tab) => {
    switch (tab) {
      case "Active":
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Document Name', datafield: 'name', width: '15%' },
          { text: 'Ref No.', datafield: 'ref_no', width: '10%' },
          { text: 'Version', datafield: 'version', width: '10%' },
          { text: 'Created', datafield: 'created_at', width: '10%' },
          { text: 'Last Updated', datafield: 'updated_at', width: '10%' },
          { text: 'Last edited by', datafield: 'updated_by', width: '10%' },
          { text: 'Organisation', datafield: 'organisation', width: '10%' },
          { text: 'Access', datafield: 'access', width: '10%' },

        ];
      case "Announcement":
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Title', datafield: 'name', width: '20%' },
          { text: 'Access', datafield: 'access', width: '20%' },
          { text: 'doc type', datafield: 'type', width: '20%' },
          { text: 'Published By', datafield: 'updated_by', width: '10%' },
          { text: 'Tarcking', datafield: 'version', width: '10%' },

        ];
      case "Departments":
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Document Title', datafield: 'name', width: '15%' },
          { text: 'Version', datafield: 'version', width: '10%' },
          { text: 'Access', datafield: 'access', width: '15%' },
          { text: 'doc type', datafield: 'type', width: '15%' },
          { text: 'updated', datafield: 'updated_at', width: '10%' },
          { text: 'Published By', datafield: 'updated_by', width: '10%' },
          //{ text: 'Tarcking', datafield: 'version', width: '10%' },

        ];
      case "Private":
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Document Title', datafield: 'name', width: '20%' },
          { text: 'Vs.', datafield: 'version', width: '10%' },
          { text: 'doc type', datafield: 'type', width: '20%' },
          { text: 'updated', datafield: 'updated_at', width: '10%' },
          { text: 'Published By', datafield: 'updated_by', width: '10%' },
        ];
      case "All_Publish":
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Document Title', datafield: 'name', width: '20%' },
          { text: 'Access', datafield: 'access', width: '10%' },
          { text: 'doc type', datafield: 'type', width: '10%' },
          { text: 'Published By', datafield: 'updated_by', width: '10%' },
          { text: 'updated', datafield: 'updated_at', width: '10%' },
          { text: 'Signed', datafield: 'is_signed', width: '10%' },
          {
            text: 'Reminder',
            datafield: 'reminder',
            width: '10%',
            filterable: false,
            cellsrenderer: () =>
              `<div style="display:flex;align-items:center;height:100%;">
          <span style="">
            <img src="${mail}" />
          </span>
        </div>`
          },
          {
            text: 'Readers',
            datafield: 'readers',
            width: '10%',
            filterable: false,
            cellsrenderer: (row, column, value, rowData) =>
              `<div style="display:flex;align-items:center;height:100%;">
      <span 
        style=""
        title="View Readers"
      >
        <img src="${show}" />
      </span>
    </div>`
          },


        ];
      case "Read_sign":
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Document Title', datafield: 'name', width: '20%' },
          { text: 'Vs.', datafield: 'version', width: '10%' },
          { text: 'Access', datafield: 'access', width: '10%' },
          { text: 'doc type', datafield: 'type', width: '20%' },
          { text: 'updated', datafield: 'updated_at', width: '10%' },
          { text: 'Published By', datafield: 'updated_by', width: '10%' },
        ];
      default:
        return [
          { text: 'Actions', cellsrenderer: actionRenderer(tab), width: '4%', filterable: false },
          { text: 'Document Name', datafield: 'name', width: '20%' },
          { text: 'Version', datafield: 'version', width: '10%' },
          { text: 'Doc Type', datafield: 'docType', width: '10%' },
          { text: 'Updated', datafield: 'updated_at', width: '15%' },
          { text: 'Publish By', datafield: 'created_by', width: '15%' },
          { text: 'Tracking', datafield: 'tracking', width: '16%' }
        ];
    }
  };

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');

  };
  // const handleChange = (field, value) => {
  //   if (field === 'is_publish' && value == '1') {
  //     setFormData(prev => ({
  //       ...prev,
  //       [field]: value,
  //       requires_login: '1',
  //       announcement: '0',
  //       read_and_sign: '1',
  //     }));
  //   } else if (field === 'publish_for') {
  //     if (value === 'private') {
  //       setFormData(prev => ({
  //         ...prev,
  //         [field]: value,
  //         read_and_sign: '0',
  //         read_sign_type: null
  //       }));
  //     } else {
  //       setFormData(prev => ({
  //         ...prev,
  //         [field]: value,
  //         read_and_sign: '1',
  //         read_sign_type: null
  //       }));
  //     }

  //   } else if (field === 'announcement' && value === '0') {
  //     setFormData(prev => ({
  //       ...prev,
  //       [field]: value,
  //       read_and_sign: '1',
  //       read_sign_type: null
  //     }));
  //   } else {
  //     setFormData(prev => ({
  //       ...prev,
  //       [field]: value
  //     }));
  //   }


  // }
  const handleChange = (field, value) => {
    setFormData(prev => {
      let updated = { ...prev, [field]: value };

      const removeFields = (fields) => {
        fields.forEach(f => delete updated[f]);
      };

      if (field === "is_publish") {
        if (value === "1") {
          updated = {
            ...updated,
            requires_login: "1",
            announcement: "0",
            read_and_sign: "1",
            publish_for: 'departments',
          };
        } else if (value === "0") {
          removeFields(["requires_login", "announcement", "read_and_sign", "read_sign_type", "publish_for", "department", "publishLink"]);
        }
      }

      if (field === "announcement") {
        if (value === "1") {
          removeFields(["read_and_sign", "read_sign_type"]);
        } else if (value === "0") {
          updated.read_and_sign = "1";
          updated.read_sign_type = null;
        }
      }

      if (field === "publish_for") {
        if (value === "private") {
          removeFields(["read_sign_type"]);
          updated.read_and_sign = "0";
        } else {
          updated.read_and_sign = "1";
          updated.read_sign_type = null;
        }
      }

      return updated;
    });
  };




  const fetchImage = async () => {
    try {
      const res = await withRFSToken.get("/file-management/list")
        .then(function (res) {
          const data = res.data.Rows;

          const transformData = data?.map(item => ({
            label: item.file_name,
            value: item.id,
            imageUrl: `${item.file_path}`
          })) || [];

          setImageOptions(transformData);

        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchdeparrtment = async () => {
    try {
      const res = await withRFSToken.get("/organisation-department/dropdown")
        .then(function (res) {

          const innerData = res.data.response_data;

          const transformData = innerData ? innerData.map((item) => ({
            label: item.label,
            value: item.value
          })) : []
          setDepartmentList(transformData)
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetctemplatehData = async () => {
    try {
      const res = await withRFSToken.post('template/dropdown?tab=document')
      const innerData = res.data.response_data;
      const transformData = innerData ? innerData.map((item) => ({
        label: item.label,
        value: item.value
      })) : []
      setTemplateData(transformData)

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  //-------------------- for image section-------->

  const [files, setFiles] = useState([]);
  const [base64Files, setBase64Files] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [editFiles, setEditFiles] = useState([]);
  const [isTopDel, setIsTopDel] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);

  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const fileInputRef = useRef(null);
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];
    let filesProcessed = 0;

    // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
    const existingBase64Files = formData?.base64Files || [];
    const existingFiles = formData?.files || [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
        filesProcessed += 1;
        if (filesProcessed === selectedFiles.length) {
          const newFiles = filesWithBase64.map((obj) => obj.file);
          // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
          const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
          const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
          const mergedFiles = [...existingFiles, ...newBase64Files];
          // setFiles(newFiles);
          setFiles((prevFiles) => [...prevFiles, ...newFiles]);
          setBase64Files(mergedBase64Files);
          setFormData((prevFormData) => {
            // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
            const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

            return newFormData;
          });
        }
      };
      reader.readAsDataURL(file);
    });
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const handleImageSelect = (key, data) => {
    // console.log("🚀 ~ handleImageSelect ~ data:", data)

    if (formData.files) {
      const extension = data?.name?.split('.').pop().toLowerCase();
      if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
        setFormData((prevFormData) => {
          const updatedFiles = prevFormData.files.map((file, index) => {
            if (index === key) {
              // Toggle the "primary" field for the selected file
              return {
                ...file,
                primary: file.primary === 1 ? 0 : 1,
              };
            }
            return file;
          });

          return {
            ...prevFormData,
            files: updatedFiles,
          };
        });

        setSelectedKeys((prevSelected) =>
          prevSelected.includes(key)
            ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
            : [...prevSelected, key] // Add key if not selected
        );
      }
    }
    if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

      setEditFiles((prevFiles) =>
        prevFiles.map((file) =>
          file.id === data.id
            ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
            : file // Leave other files unchanged
        )
      );
    }

  };

  const handleDeleteFile = (index, id, type) => {
    if (isTopDel) {
      setEditFiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles.splice(index, 1);
        return newFiles;
      });
    } else {
      setFiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles.splice(index, 1);
        return newFiles;
      });
      // base64Files.splice(index, 1);
      setBase64Files((prevBase64Files) => {
        const newBase64Files = [...prevBase64Files];
        newBase64Files.splice(index, 1);

        // Update local storage
        setFormData((prevFormData) => {
          const newFormData = { ...prevFormData, base64Files: newBase64Files };
          return newFormData;
        });

        return newBase64Files;
      });
    }

  };

  //<---------------------end---------------------------->

  //  npm install mammoth pdfjs-dist

  //<------------------------convert file dox and pdf--------------------->
  const [selectedFile, setSelectedFile] = useState(null);
  const [extractedText, setExtractedText] = useState('');

  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const fileInputRef1 = useRef(null);

  const handleBrowseFiles1 = (e) => {
    e.preventDefault();
    fileInputRef1.current.click();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];

    const isValidFile = (
      file?.type === 'application/pdf' ||
      file?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file?.type === 'application/msword' ||
      file?.name.toLowerCase().endsWith('.doc') ||
      file?.name.toLowerCase().endsWith('.docx') || ''
    );

    if (file && isValidFile) {
      setSelectedFile(file);
      setError('');
      setExtractedText('');
    } else {
      setError('Please select a valid PDF, DOC, or DOCX file');
      setSelectedFile(null);
    }
  };

  const convertDocumentToText = async () => {
    if (!selectedFile) return;

    // setIsLoading(true);
    setError('');
    setExtractedText('');

    try {
      const fileExtension = selectedFile.name.toLowerCase().split('.').pop();
      let extractedContent = '';

      if (fileExtension === 'pdf') {
        extractedContent = await convertPdfToHtml();
      } else if (fileExtension === 'doc' || fileExtension === 'docx') {
        extractedContent = await convertWordToHtml();
      }

      if (extractedContent.trim()) {
        setExtractedText(extractedContent.trim());
        setFormData(prev => ({
          ...prev,
          content: extractedContent.trim()
        }));
      } else {
        setError('No content found in the document. The file might contain only images or be password protected.');
      }

    } catch (err) {
      setError(`Error converting document: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const convertPdfToHtml = async () => {
    let pdfjsLib = window.pdfjsLib;

    if (!pdfjsLib) {
      await new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
        script.onload = () => {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      pdfjsLib = window.pdfjsLib;
    }

    const arrayBuffer = await selectedFile.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    let html = "<div class='pdf-html'>";
    let buffer = ""; // to collect paragraph text

    for (let p = 1; p <= pdf.numPages; p++) {
      const page = await pdf.getPage(p);
      const content = await page.getTextContent();

      html += `<div class='page' data-page='${p}'>`;

      let lastY = null; // track line changes

      content.items.forEach((item, i) => {
        const text = item.str.trim();
        if (!text) return;

        const fontSize = Math.round(item.height); // Heading detection
        const y = Math.floor(item.transform[5]); // Y axis for line grouping

        const isBullet = /^(\•|\-|\–|\*)/.test(text);

        // Detect new line
        if (lastY !== null && Math.abs(lastY - y) > 6) {
          if (buffer.trim()) {
            html += `<p>${buffer.trim()}</p>`;
            buffer = "";
          }
        }

        // HEADINGS (PDF usually > 14px)
        if (fontSize >= 14 && !isBullet && text.length <= 60) {
          if (buffer.trim()) {
            html += `<p>${buffer.trim()}</p>`;
            buffer = "";
          }
          html += `<h3>${text}</h3>`;
        }

        // BULLET LIST
        else if (isBullet) {
          if (!html.endsWith("<ul>")) {
            if (buffer.trim()) html += `<p>${buffer.trim()}</p>`;
            buffer = "";
            html += "<ul>";
          }
          html += `<li>${text.replace(/^(\•|\-|\–|\*)/, "").trim()}</li>`;
        }

        // NORMAL PARAGRAPH CONTENT
        else {
          buffer += text + " ";
        }

        lastY = y;
      });

      // Close leftover text in buffer
      if (buffer.trim()) {
        html += `<p>${buffer.trim()}</p>`;
        buffer = "";
      }

      // Close <ul> if still open
      if (html.endsWith("</li>")) {
        html += "</ul>";
      }

      html += "</div>"; // page end
    }

    html += "</div>";
    return html;
  };


  // const convertPdfToHtml = async (file) => {
  //   const fileReader = new FileReader();

  //   return new Promise((resolve, reject) => {
  //     fileReader.onload = async () => {
  //       const data = new Uint8Array(fileReader.result);

  //       try {
  //         const pdf = await pdfjsLib.getDocument({ data }).promise;
  //         let finalHTML = `<div class="pdf-html">`;

  //         for (let i = 1; i <= pdf.numPages; i++) {
  //           const page = await pdf.getPage(i);
  //           const text = await page.getTextContent();

  //           finalHTML += mapPdfContentToHtml(text.items);
  //         }

  //         finalHTML += `</div>`;
  //         resolve(finalHTML);
  //       } catch (err) {
  //         reject(err);
  //       }
  //     };

  //     fileReader.readAsArrayBuffer(file);
  //   });
  // };
  const mapPdfContentToHtml = (items) => {
    let html = "";
    let buffer = "";

    items.forEach((item) => {
      const text = item.str.trim();
      if (!text) return;

      const fontSize = item.transform[0]; // used to detect headings

      // Heading
      if (fontSize > 12) {
        html += `<h3>${text}</h3>`;
      }
      // Bulleted list
      else if (/^[•|\-]/.test(text)) {
        buffer += `<li>${text.replace(/^•|\-/, "").trim()}</li>`;
      }
      // Normal paragraph
      else {
        buffer += `${text} `;
      }
    });

    // Wrap bullets or paragraph
    if (buffer.includes("<li>")) buffer = `<ul>${buffer}</ul>`;
    else buffer = `<p>${buffer}</p>`;

    html += buffer;
    return html;
  };


  const convertWordToHtml = async () => {
    const arrayBuffer = await selectedFile.arrayBuffer();

    const result = await mammoth.convertToHtml({ arrayBuffer });
    console.log('Conversion result:', result);

    if (result.messages && result.messages.length > 0) {
      console.warn('Conversion warnings:', result.messages);
    }

    return `<div class="word-content">${result.value}</div>`;
  };

  const addDocumentStyles = () => {
    const styles = `
    <style>
      .pdf-content, .word-content {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        color: #333;
      }
      .page {
        margin-bottom: 30px;
        padding: 20px;
        border-bottom: 1px solid #eee;
      }
      .page h3 {
        color: #666;
        font-size: 18px;
        margin-bottom: 15px;
        border-bottom: 2px solid #007bff;
        padding-bottom: 5px;
      }
      .page h4 {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        margin: 15px 0 10px 0;
      }
      .page p {
        margin-bottom: 10px;
        text-align: justify;
      }
      .word-content h1, .word-content h2, .word-content h3 {
        color: #333;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .word-content p {
        margin-bottom: 10px;
        text-align: justify;
      }
      .word-content ul, .word-content ol {
        margin: 10px 0;
        padding-left: 30px;
      }
      .word-content table {
        border-collapse: collapse;
        width: 100%;
        margin: 15px 0;
      }
      .word-content th, .word-content td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }
      .word-content th {
        background-color: #f2f2f2;
        font-weight: bold;
      }
    </style>
  `;
    return styles;
  };

  // Update the convert button click handler to include styles:
  const handleConvertWithStyles = async () => {
    await convertDocumentToText();

    // If you want to include CSS styles in the HTML output:
    if (formData.content) {
      const styledContent = addDocumentStyles() + formData.content;
      setFormData(prev => ({
        ...prev,
        content: styledContent
      }));
    }
  };


  const resetConverter = () => {
    setSelectedFile(null);
    setExtractedText('');
    setError('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };



  //<------------------------end------------------------------------------>

  const handleDoccreate = () => {
    setCreateModal(true);
    setFormData(initFdata)
    setSelectedFile(null);
  }

  const saveDoc = async () => {
    //setCreateModal(false);
    // console.log("formData==>", formData);
    setDisLoading(true);
    try {
      const res = await withRFSToken.post("document/add-update", formData);
      if (res.data.response_code == 200) {
        setCreateModal(false)

        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        toast.success(res.data.response_msg);

      } else {

        toast.error(res.data.response_msg);
      }
      setDisLoading(false);
    } catch (error) {
      console.error('Error sending request:', error);
      setDisLoading(false);
    }
  }

  const formatOptionLabel = ({ label, imageUrl }, { context }) => {
    const truncateLabel = (label) => {
      if (label.length <= 3) return label;
      return label.slice(0, 3) + '...';
    };

    const displayLabel = context === 'value' ? truncateLabel(label) : label;

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={imageUrl} alt={label} style={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 4, marginRight: 10 }} />
        <span>{displayLabel}</span>
      </div>
    );
  };

  const handlePrint = () => {
    window.print();
  };

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      // console.log("checked==>", e.target.checked);

      setShowConfirm(true);
    } else {

      setIsChecked(false);
    }
  };

  const handleConfirmYes = () => {
    setIsChecked(true);
    setShowConfirm(false);
  };

  const handleConfirmCancel = () => {
    setIsChecked(false);
    setShowConfirm(false);
  };
  const updateStatus = async () => {
    if (!isChecked) {
      toast.error("Please confirm that you have read and understood the document.");
      return;
    }
    // console.log("formData for sign==>", formData.id);
    return false;
    setDisLoading(true);
    try {
      const res = await withRFSToken.post("document/update-signed", { id: formData.id });
      if (res.data.response_code == 200) {
        setViewModal(false)
        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        toast.success(res.data.response_msg);
      } else {
        toast.error(res.data.response_msg);
      }
      setDisLoading(false);
    }
    catch (error) {
      console.error('Error sending request:', error);
      setDisLoading(false);
    }
  }


  return (
    <>
      {console.log("formData==>", formData)}
      {console.log("ActiveTab==>", activeTab)}
      <div className="">
        <Header page_type='QMS' logo_url='/DocumentManagement' />
        <div className='d-flex justify-content-between slot_plan_hd'>
          {/* <div className='new_menu_serv'>
            <button className={selectedButton === 'dashboard' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('dashboard')}>
              <img src={selectedButton === 'dashboard' ? AssetsIconA : AssetsIcon} /> <span>Dashboard</span>
            </button>
            <button className={selectedButton === 'overview' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('overview')}>
              <img src={selectedButton === 'overview' ? OperationIconA : OperationIcon} /> <span>Overview</span>
            </button>
            <button className={selectedButton === 'inbox' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('inbox')}>
              <img src={selectedButton === 'inbox' ? OnAirIconA : OnAirIcon} /> <span>Inbox</span>
            </button>
            <button className={selectedButton === 'task' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('task')}>
              <img src={selectedButton === 'task' ? OnAirIconA : OnAirIcon} /> <span>Task Management</span>
            </button>
            <button className={selectedButton === 'doc' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('doc')}>
              <img src={selectedButton === 'doc' ? OnAirIconA : OnAirIcon} /> <span>Doc Management</span>
            </button>
          </div> */}
        </div>
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel rounded">
            <div className="mainTab">
              <div className="lcontent">
                <div className="lcontent">

                  <div className="mb-3 nestedtabs rounded minh">
                    <div className='d-flex'>
                      {/* <button className="addtruck me-2" variant="primary" onClick={handleDoccreate} >
                        <span> <FontAwesomeIcon icon={faPlus} /> Create Doc</span>
                      </button> */}

                    </div>
                  </div>

                  <div className="maindiv">
                    <div className='trashdonload'>
                      {disLoading &&
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                      }
                      <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        {/* <Tab eventKey="Active" title={<span> Active </span>} className='moveto'>
                          {!isLoading && <>
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            <div ref={gridRefs.Active} className='bookinggrid' ></div>
                          </>
                          }

                        </Tab> */}
                        <Tab eventKey="Announcement" title={<span>Announcement </span>} className='moveto'>
                          {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                          {!isLoading && <div ref={gridRefs.Announcement} className='bookinggrid' ></div>}
                        </Tab>
                        <Tab eventKey="Departments" title={<span>Departments </span>} className='moveto'>
                          {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                          {!isLoading && <div ref={gridRefs.Departments} className='bookinggrid' ></div>}
                        </Tab>
                        <Tab eventKey="Private" title={<span>Private </span>} className='moveto'>
                          {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                          {!isLoading && <div ref={gridRefs.Private} className='bookinggrid' ></div>}
                        </Tab>
                        <Tab eventKey="All_Publish" title={<span>All Publish </span>} className='moveto'>
                          {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                          {!isLoading && <div ref={gridRefs.All_Publish} className='bookinggrid' ></div>}
                        </Tab>
                        <Tab eventKey="Read_sign" title={<span> Read &amp; Sign<span className="badge bg-primary ms-1"> {tabCounts.Read_sign !== undefined ? parseInt(tabCounts.Read_sign) : 0}</span> </span>} className="moveto" >
                          {filterApplied ? (
                            <div className="clear_filter">
                              <Button onClick={resetFilters}>Reset Filters</Button>
                            </div>
                          ) : null}
                          {!isLoading && <div ref={gridRefs.Read_sign} className="bookinggrid"></div>}
                        </Tab>
                      </Tabs>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={createModal} onHide={() => setCreateModal(false)} className='add_task_modal' centered size="xl">
        <Modal.Header closeButton >
          <h6>
            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
            Create new document
          </h6>
        </Modal.Header>
        <Modal.Body>
          <Form className='add_taskForm'>
            <Row>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <Form.Label>Document Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Document Name"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                />
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <Form.Label>Version</Form.Label>
                <Form.Control
                  type="text"
                  name="version"
                  placeholder="1.0"
                  value={formData.version}
                  onChange={(e) => handleChange('version', e.target.value)}
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <Form.Label>Use Template</Form.Label>
                <Select
                  options={templateData}
                  value={templateData.find(option => option.value == formData?.template_id) || ''}
                  onChange={selected => handleChange('template_id', selected ? selected.value : '')}
                  placeholder="Select template"
                  isClearable
                />
                {/* <Form.Label>Assign to Recovery</Form.Label>
                <Select
                  options={awbList}
                  value={awbList.find(option => option.value == formData?.documentable_id) || null}
                  onChange={selected => setFormData({
                    ...formData,
                    documentable_id: selected?.value,
                    documentable_type: selected?.documentable_type,
                  })}
                  placeholder="Select AWB"
                /> */}
              </Form.Group>
              <Form.Group as={Col} md="3" controlId="validationCustom01">
                <Form.Label>Attached File</Form.Label>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  options={imageOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={imageOptions.filter(opt => formData.doc_upload?.includes(opt.value))}
                  onChange={(selectedOptions) => {
                    const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                    handleChange('doc_upload', values);
                  }}
                  placeholder="Select files"
                  formatOptionLabel={formatOptionLabel}
                />
              </Form.Group>
              <Form.Group as={Col} md="3" controlId="validationCustom01">
                <Form.Label></Form.Label>
                <div className="dropfile dropfiles" style={{ display: 'flex', alignItems: 'center', padding: '8px', border: '1px dashed #ccc', borderRadius: '5px', }} onDrop={handleDrop} onDragOver={handleDragOver} >
                  <h3 style={{ margin: 0, fontSize: '14px' }}>Drag and drop files here</h3>
                  <button className='btn btn-primary drpbtn' style={{ padding: '4px 8px', fontSize: '12px', height: '30px', lineHeight: '20px' }} onClick={handleBrowseFiles}>
                    Browse
                  </button>
                  <input type="file" ref={fileInputRef} onChange={handleFileChange} style={{ display: 'none' }}
                    multiple
                  />
                </div>
                {files?.map((file, index) => {
                  const fileName = typeof file.name === "string" ? file.name : "";
                  const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                  const extension = fileName?.split(".").pop()?.toLowerCase();
                  return (
                    <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                      {["jpeg", "jpg", "png", "webp"].includes(extension)
                        ? (
                          <>
                            <img
                              src={URL.createObjectURL(file)}
                              alt="Preview"
                              style={{
                                maxWidth: "30px",
                                maxHeight: "30px",
                                marginRight: "5px",
                              }}
                            />
                            <span>
                              {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                            </span>
                          </>
                        ) : (
                          <span className="d-flex align-items-center">
                            <img src={Docmnt} style={{
                              maxWidth: "30px",
                              maxHeight: "30px",
                              marginRight: "5px",
                            }} />
                            <span>{fileName}</span>
                          </span>
                        )}
                      <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                    </div>
                  )
                })}
              </Form.Group>
              <div className='ship_head' ></div>
              <Col sm={6}>
                <Form.Group as={Row} className="mb-3" controlId="publish">
                  <Form.Label column sm="3">
                    Publish <span title="Info"></span>
                  </Form.Label>
                  <Col sm="8" className="d-flex align-items-center">
                    <Form.Check
                      inline
                      label="Yes"
                      name="is_publish"
                      type="radio"
                      value="1"
                      checked={formData.is_publish === '1'}
                      onChange={(e) => handleChange('is_publish', e.target.value)}
                    />

                    <div className="d-inline-flex align-items-center">
                      <Form.Check
                        inline
                        label="No"
                        name="is_publish"
                        type="radio"
                        value="0"
                        className='me-1'
                        checked={formData.is_publish === '0'}
                        onChange={(e) => handleChange('is_publish', e.target.value)}
                      />
                      {formData.is_publish === '1' && (
                        <span className="text-danger small ms-0">
                          Turning off will invalidate existing link!
                        </span>
                      )}
                    </div>
                  </Col>
                </Form.Group>

                {formData.is_publish === '1' && (
                  <>
                    <Form.Group as={Row} className="mb-3" controlId="requiresLogin">
                      <Form.Label column sm="3">
                        Requires login <span title="Info"></span>
                      </Form.Label>
                      <Col sm="8">
                        <Form.Check
                          inline
                          label="Yes"
                          name="requires_login"
                          type="radio"
                          value="1"
                          checked={formData.requires_login === '1'}
                          onChange={(e) => handleChange('requires_login', e.target.value)}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="requires_login"
                          type="radio"
                          value="0"
                          checked={formData.requires_login === '0'}
                          onChange={(e) => handleChange('requires_login', e.target.value)}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="announcement">
                      <Form.Label column sm="3">Announcement <span title="Info"></span></Form.Label>
                      <Col sm="4">
                        <Form.Check
                          inline
                          label="Yes"
                          name="announcement"
                          type="radio"
                          value="1"
                          checked={formData.announcement === '1'}
                          onChange={(e) => handleChange('announcement', e.target.value)}
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="announcement"
                          type="radio"
                          value="0"
                          className='p-0'
                          checked={formData.announcement === '0'}
                          onChange={(e) => handleChange('announcement', e.target.value)}
                        />
                      </Col>
                      {formData.announcement === '1' && (
                        <>
                          <Form.Label column sm="3">No. of Days <span title="Info"></span></Form.Label>
                          <Col sm={2}>
                            <Form.Control
                              type="text"
                              value={formData.announcement_days || '30'}
                              onChange={(e) => handleChange('announcement_days', e.target.value)}
                            />
                          </Col>
                        </>
                      )}
                    </Form.Group>

                    {formData.announcement == '0' &&
                      <Form.Group as={Row} className="mb-3" controlId="readSign">
                        <Form.Label column sm={3}>
                          Read & Sign <span title="Info"></span>
                        </Form.Label>

                        {/* Radio buttons */}
                        <Col sm={5}>
                          <Form.Check
                            inline
                            label="Yes"
                            name="read_and_sign"
                            type="radio"
                            value="1"
                            checked={formData.read_and_sign === '1'}
                            onChange={(e) => handleChange('read_and_sign', e.target.value)}
                          />
                          <Form.Check
                            inline
                            label="No"
                            name="read_and_sign"
                            type="radio"
                            value="0"
                            checked={formData.read_and_sign === '0'}
                            className='me-1'
                            onChange={(e) => handleChange('read_and_sign', e.target.value)}
                          />
                        </Col>


                        {formData.read_and_sign === '1' && (
                          <Col sm={3}>
                            <Select
                              options={readSignType}
                              value={
                                readSignType.find(option => option.value === formData.read_sign_type) || null
                              }
                              onChange={(selected) =>
                                handleChange('read_sign_type', selected ? selected.value : '')
                              }
                              placeholder="Select"
                              isClearable
                              className='read_sign_select'
                            />
                          </Col>
                        )}
                      </Form.Group>
                    }
                  </>
                )}

              </Col>
              {formData.is_publish === '1' && (
                <>
                  <Col sm={6}>
                    <Form.Group as={Row} className="mb-3" controlId="publishLink">
                      <Form.Label column sm="3">Publish Link:</Form.Label>
                      <Col sm="9" className="d-flex">
                        <Form.Control
                          type="text"
                          value={formData.publishLink}
                          onChange={(e) => setFormData({ ...formData, publishLink: e.target.value })}
                        />
                        <button type="button" className="btn btn-primary ms-2 publish_link_cpy">Copy</button>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="formPublishFor">
                      <Form.Label column sm="3">Publish For:</Form.Label>
                      <Col sm="8">
                        <Form.Check
                          inline
                          label="Private"
                          name="publish_for"
                          type="radio"
                          value="private"
                          checked={formData.publish_for === 'private'}
                          onChange={(e) => handleChange('publish_for', e.target.value)}
                        />
                        <Form.Check
                          inline
                          label="Departments"
                          name="publish_for"
                          type="radio"
                          value="departments"
                          checked={formData.publish_for === 'departments'}
                          onChange={(e) => handleChange('publish_for', e.target.value)}
                        />
                      </Col>
                    </Form.Group>

                    {formData.publish_for === 'departments' && (
                      <Form.Group as={Row} className="mb-3" controlId="formPlaintextDepartment">
                        <Form.Label column sm="3">Department</Form.Label>
                        <Col sm="9">
                          <Select
                            isMulti
                            options={departmentList}
                            value={departmentList.filter(option =>
                              formData.department_id.includes(option.value)
                            )}
                            onChange={selected =>
                              handleChange(
                                'department_id',
                                selected ? selected.map(opt => opt.value) : []
                              )
                            }
                            placeholder="Select departments"
                            isClearable
                          />
                        </Col>
                      </Form.Group>
                    )}
                  </Col>
                </>
              )}

              <div className='ship_head' ></div>

              <Col>
                <Form.Group as={Col} md="12" controlId="validationCustom01">
                  <Form.Label>Upload Document</Form.Label>
                  <div className="dropfile">
                    <h3>Drag and drop files here</h3>
                    <button
                      className='btn btn-primary drpbtn'
                      type="button"
                      onClick={handleBrowseFiles1}
                    >
                      Browse Files
                    </button>
                    <span>Maximum file size 4 MB</span>
                    <input
                      type="file"
                      ref={fileInputRef1}
                      onChange={handleFileSelect}
                      accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword"
                      style={{ display: 'none' }}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group as={Col} md="12" controlId="validationCustom01">
                  <Form.Label>Upload Document Preview</Form.Label>

                  <div
                    className="dropfile"
                    style={{
                      height: '117px',
                      border: '1px dashed #ccc',
                      borderRadius: '6px',
                      backgroundColor: '#f8f9fa',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      padding: '20px'
                    }}>
                    {/* <FontAwesomeIcon icon={faTrash} className='upld_doc_ddlt' /> */}
                    {selectedFile ? (
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ marginBottom: '10px', fontSize: '40px' }}>
                          {selectedFile.name.toLowerCase().endsWith('.pdf') ? '📄' : '📝'}
                        </div>
                        <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '5px' }}>
                          {selectedFile.name}
                        </div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {(selectedFile.size / 1024).toFixed(1)} KB
                        </div>
                        <FontAwesomeIcon icon={faTrash} className='upld_doc_ddlt' onClick={resetConverter} />
                      </div>

                    ) : (
                      <div style={{ textAlign: 'center', color: '#999' }}>
                        <div style={{ fontSize: '40px', marginBottom: '10px' }}>📄</div>
                        <span>No file selected</span>
                      </div>
                    )}
                  </div>

                  <div className="mt-3 d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={convertDocumentToText}
                      disabled={!selectedFile}
                    >
                      Convert for Publication
                    </button>
                  </div>
                </Form.Group>
              </Col>


              <Col md="12">
                <div className='edithtml' >
                  <MessageBox
                    value={formData.content || ''}
                    onMessageChange={content => handleChange('content', content)}
                  />

                </div>
              </Col>

            </Row>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-100 mx-auto are_bottom justify-content-center'>
            <Button variant="primary" onClick={() => saveDoc()}>
              Save
            </Button>

          </div>
        </Modal.Footer>
      </Modal>

      <style>
        {`
      .document-modal h4 {
        font-size: 20px;
        font-weight: bold;
      }
      .document-modal .bg-light {
        background-color: #f8f9fa !important;
      }
      .document-modal .bg-dark {
        background-color: #1c1c1c !important;
        border-radius: 8px;
      }
    `}
      </style>
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .modal-content, .modal-content * {
              visibility: visible;
            }
            .modal-content {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              box-shadow: none !important;
              border: none !important;
            }
          }
        `}
      </style>

      <Modal show={viewModal} onHide={() => setViewModal(false)} className="document-modal add_task_modal" centered size="lg">
        <Modal.Header closeButton>
          <h5 className="mb-0">
            <FontAwesomeIcon icon={faFileAlt} className="me-2 text-primary" />
            {formData?.name || "View Document"}
          </h5>
          {/* Print Icon on right side */}
          <div className="ms-auto">
            <Button
              variant="light"
              size="sm"
              onClick={handlePrint}
              title="Print Document"
            >
              <FontAwesomeIcon icon={faPrint} />
            </Button>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* Document Title + ID */}
          <div className="mb-3">
            <h4 className="fw-bold">{formData?.name}</h4>
            <p className="text-muted mb-1">
              ID : <span className="fw-semibold">{formData?.docId}</span>
            </p>
            <hr />
          </div>

          {/* Content Preview */}
          <div className="mb-4">
            <div
              className="p-3 border rounded bg-light"
              style={{ maxHeight: 250, overflowY: "auto" }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: innerData?.content || "<i>No content available</i>",
                }}
              />
            </div>
          </div>

          {/* Attached Documents */}
          <div className="p-3 bg-light rounded mb-3">
            <h6 className="fw-bold">Attached Documents</h6>
            <p className="text-muted small">No attachments available</p>
          </div>

          {/* Read & Sign */}
          <div className="d-flex justify-content-end align-items-center mb-3">
            <input
              type="checkbox"
              id="readSign"
              className="me-2"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="readSign" className="mb-0">
              Read & Sign
            </label>
          </div>

          {/* Footer Meta Info */}
          <div className="bg-dark text-white p-3 rounded small">
            <Row>
              <Col md={6}>
                <p className="mb-1">
                  <strong>Ref.No:</strong> {innerData?.ref_no}
                </p>
                <p className="mb-1">
                  <strong>Created by:</strong> {formData?.created_by}
                </p>
                <p className="mb-1">
                  <strong>Last Edited by:</strong> {formData?.updated_by}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-1">
                  <strong>Version:</strong> {formData?.version}
                </p>
                <p className="mb-1">
                  <strong>Last Update:</strong> {formData?.updated_by}
                </p>
                <p className="mb-1">
                  <strong>Published by:</strong> {formData?.updated_by}
                </p>
              </Col>
            </Row>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setViewModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => updateStatus()}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirm} onHide={handleConfirmCancel} centered style={{ zIndex: 9999 }} >
        <Modal.Body className="text-center">
          <p>Do you want to save this as signed?</p>
          <div className="d-flex justify-content-center gap-2 mt-3">
            <Button variant="primary" onClick={handleConfirmYes}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleConfirmCancel}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showReadersModal} onHide={() => setShowReadersModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Readers for Row ID: {selectedRowId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Your content here */}
        </Modal.Body>
      </Modal>

    </>
  )
}

export default DocManagement;

